import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=0b646a76&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b646a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b646a76')) {
      api.createRecord('0b646a76', component.options)
    } else {
      api.reload('0b646a76', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=0b646a76&scoped=true", function () {
      api.rerender('0b646a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybqygl/index copy.vue"
export default component.exports